/* tslint:disable */
/* eslint-disable */
/**
 * Yaway API
 * Yaway API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiClaimIncidentType,
    ApiClaimIncidentTypeFromJSON,
    ApiClaimIncidentTypeToJSON,
    ApiWorkshop,
    ApiWorkshopFromJSON,
    ApiWorkshopToJSON,
} from '../models';

export interface GetAllPartnerWorkshopsRequest {
    externalId: number;
    incidentType: ApiClaimIncidentType;
    vehicleMark: string;
    vehicleYear?: number;
}

export interface GetAllPartnerWorkshopsByClaimRequest {
    claimExternalId: string;
    incidentType: ApiClaimIncidentType;
    vehicleMark: string;
    vehicleYear?: number;
}

/**
 * 
 */
export class PartnerWorkshopApi extends runtime.BaseAPI {

    /**
     * get all partner workshops
     */
    async getAllPartnerWorkshopsRaw(requestParameters: GetAllPartnerWorkshopsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ApiWorkshop>>> {
        if (requestParameters.externalId === null || requestParameters.externalId === undefined) {
            throw new runtime.RequiredError('externalId','Required parameter requestParameters.externalId was null or undefined when calling getAllPartnerWorkshops.');
        }

        if (requestParameters.incidentType === null || requestParameters.incidentType === undefined) {
            throw new runtime.RequiredError('incidentType','Required parameter requestParameters.incidentType was null or undefined when calling getAllPartnerWorkshops.');
        }

        if (requestParameters.vehicleMark === null || requestParameters.vehicleMark === undefined) {
            throw new runtime.RequiredError('vehicleMark','Required parameter requestParameters.vehicleMark was null or undefined when calling getAllPartnerWorkshops.');
        }

        const queryParameters: any = {};

        if (requestParameters.incidentType !== undefined) {
            queryParameters['incidentType'] = requestParameters.incidentType;
        }

        if (requestParameters.vehicleMark !== undefined) {
            queryParameters['vehicleMark'] = requestParameters.vehicleMark;
        }

        if (requestParameters.vehicleYear !== undefined) {
            queryParameters['vehicleYear'] = requestParameters.vehicleYear;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/services/{externalId}/workshops`.replace(`{${"externalId"}}`, encodeURIComponent(String(requestParameters.externalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiWorkshopFromJSON));
    }

    /**
     * get all partner workshops
     */
    async getAllPartnerWorkshops(requestParameters: GetAllPartnerWorkshopsRequest, initOverrides?: RequestInit): Promise<Array<ApiWorkshop>> {
        const response = await this.getAllPartnerWorkshopsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get all partner workshops by claim external id
     */
    async getAllPartnerWorkshopsByClaimRaw(requestParameters: GetAllPartnerWorkshopsByClaimRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ApiWorkshop>>> {
        if (requestParameters.claimExternalId === null || requestParameters.claimExternalId === undefined) {
            throw new runtime.RequiredError('claimExternalId','Required parameter requestParameters.claimExternalId was null or undefined when calling getAllPartnerWorkshopsByClaim.');
        }

        if (requestParameters.incidentType === null || requestParameters.incidentType === undefined) {
            throw new runtime.RequiredError('incidentType','Required parameter requestParameters.incidentType was null or undefined when calling getAllPartnerWorkshopsByClaim.');
        }

        if (requestParameters.vehicleMark === null || requestParameters.vehicleMark === undefined) {
            throw new runtime.RequiredError('vehicleMark','Required parameter requestParameters.vehicleMark was null or undefined when calling getAllPartnerWorkshopsByClaim.');
        }

        const queryParameters: any = {};

        if (requestParameters.incidentType !== undefined) {
            queryParameters['incidentType'] = requestParameters.incidentType;
        }

        if (requestParameters.vehicleMark !== undefined) {
            queryParameters['vehicleMark'] = requestParameters.vehicleMark;
        }

        if (requestParameters.vehicleYear !== undefined) {
            queryParameters['vehicleYear'] = requestParameters.vehicleYear;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/claims/{claimExternalId}/workshops`.replace(`{${"claimExternalId"}}`, encodeURIComponent(String(requestParameters.claimExternalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiWorkshopFromJSON));
    }

    /**
     * get all partner workshops by claim external id
     */
    async getAllPartnerWorkshopsByClaim(requestParameters: GetAllPartnerWorkshopsByClaimRequest, initOverrides?: RequestInit): Promise<Array<ApiWorkshop>> {
        const response = await this.getAllPartnerWorkshopsByClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
